<mat-card class="coverage-map-widget-container">
  <div #exportContent>
    <div class="header">
      <span class="title">EAGLE-I&trade; Coverage Map</span>
      <button class="header-btn" data-html2canvas-ignore mat-icon-button (click)="export()">
        <vulcan-icon size="24px" icon="download"></vulcan-icon>
      </button>
    </div>
    <div class="content">
      <div class="map-container">
        <tgrid-map [mapId]="mapId" hideAppState></tgrid-map>

        <div class="legend" #legendContent>
          <div>
            <div class="legend-label" [style.background-color]="'#7b3294'">0%</div>
            <div class="legend-label" [style.background-color]="'#c2a5cf'">20%</div>
            <div class="legend-label" [style.background-color]="'#f7f7f7'">40%</div>
            <div class="legend-label" [style.background-color]="'#a6dba0'">60%</div>
            <div class="legend-label" [style.background-color]="'#008837'">>80%</div>
          </div>
          <div class="legend-label no-data">
            <div class="color-circle" [style.background-color]="'#444444'"></div>
            <span>Not Covered</span>
          </div>
        </div>
      </div>
      <small class="map-note">Image Source: EAGLE-I™</small>
      <p>
        Approximately {{ statePercentile() | number : '1.0-2' }}% of {{ stateName() }}'s electricity customer outages
        are captured in EAGLE-I™
      </p>
    </div>
  </div>
</mat-card>
